import { TemplateDispatchRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function TemplateDispatchRouteComponent() {
  const { templateId } = Route.useParams();

  return <TemplateDispatchRoute templateId={templateId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/template/$templateId')({
  component: TemplateDispatchRouteComponent,
});
